<template>
  <div>
    <div
      :style="{ width: width }"
      @click="openDatePickerModel"
      class="date-picker-btn"
      :class="[btnStyle]"
    >
      <slot></slot>
    </div>
    <v-dialog location="center" v-model="isDatePickerOpen">
      <!-- <modal-container :showCloseBtn="false" :showOverlay="false"> -->
      <v-locale-provider rtl>
        <!-- <span class="mb-2 text-end close-icon" @click="closeDatePickerModel">
            <v-icon size="25" color="black" icon="mdi-close" />
          </span> -->
        <v-date-picker
          class="date-picker-model"
          prev-icon="mdi-chevron-right"
          next-icon="mdi-chevron-left"
          v-model="orderDate"
          :header="header"
        >
        </v-date-picker>
      </v-locale-provider>
      <!-- </modal-container> -->
    </v-dialog>
  </div>
</template>

<script>
// import Backdrop from "./backdrop.vue";
// import cardModel from "./card-model.vue";
// import ModalContainer from "../UI/modals/modal-container.vue";
export default {
  emits: ["update:modelValue", "trigger-date-picker-update", "openModal"],
  props: {
    modelValue: {
      type: Date,
    },
    orderCurDate: {
      type: String,
    },
    width: {
      type: String,
    },
    header: {
      type: String,
    },
    disableDefaultBtnStyle: {
      type: Boolean,
    },
  },
  data() {
    return {
      orderDate: undefined,
      isDatePickerOpen: false,
    };
  },
  mounted() {
    this.orderDate = this.modelValue;
  },
  watch: {
    orderDate(newValue) {
      this.$emit("update:modelValue", newValue);
    },
    isDatePickerOpen(value) {
      if (!value) this.$emit("trigger-date-picker-update", this.orderDate);
      this.orderDate = this.modelValue;
    },
  },
  computed: {
    btnStyle() {
      return this.disableDefaultBtnStyle ? "disabled" : "";
    },
  },
  methods: {
    formattedDate(date) {
      return date.replace("T00:00:00+02:00", "");
    },
    openDatePickerModel() {
      this.$emit("openModal");
      this.isDatePickerOpen = true;
    },
    closeDatePickerModel() {
      this.$emit("update:modelValue");
      this.$emit("trigger-date-picker-update", this.orderDate);
      this.orderDate = this.modelValue;
      this.isDatePickerOpen = false;
    },
  },
};
</script>

<style>
/* .v-input__control {
  padding-left: 10px;
}
.v-field--variant-plain {
  --v-field-padding-top: 12px !important;
  --v-field-padding-bottom: 12px !important;
}
.v-input--density-default {
  --v-input-padding-top: 0px !important;
}
.v-locale--is-rtl .v-date-picker-controls__month {
  flex-direction: row !important;
} */

.date-picker-model {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.date-picker-btn {
  border-radius: 50px;
  display: flex;
  align-items: center;
  box-shadow: 0px 0px 2px 0px #00000040 !important;
  height: 100%;
}

.date-picker-btn > div {
  width: 100%;
}

.date-picker-btn.disabled {
  box-shadow: unset !important;
}

.close-icon {
  position: absolute;
  left: 8px;
  top: 8px;
  cursor: pointer;
}
</style>
